import React from "react";
import { useWindowDimensions } from "react-native";
import RenderHtml from "react-native-render-html";

function autoLinkify(html) {
  const urlRegex = /((https?:\/\/[^\s<]+))/g;
  return html.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}

const CustomHtml = ({ html, ...props }) => {
  const { width } = useWindowDimensions();
  const processedHtml = autoLinkify(html ?? "");

  return <RenderHtml contentWidth={width} source={{ html: processedHtml }} tagsStyles={customStyles} {...props} />;
};

const customStyles = {
  body: {
    fontFamily: "Inter",
    fontSize: 16,
    color: "#344054",
    lineHeight: 24,
    paragraphSpacing: 16,
  },
  h1: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#344054",
  },
  p: {
    fontFamily: "Inter",
    fontSize: 16,
    lineHeight: 24,
    color: "#344054",
    paragraphSpacing: 16,
  },
  a: {
    color: "#1e90ff",
    textDecorationLine: "underline",
  },
};

export default CustomHtml;
